import HeroContainer from "../../containers/HeroContainer.tsx";
import { Box, Stack, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import Dashboard from "../Dashboard.tsx";

const DashboardPage = () => (
  <HeroContainer
    headerContent={
      <Stack sx={{ padding: 2 }} spacing={2}>
        <Typography
          variant={"h3"}
          color={"primary.contrastText"}
          align={"center"}
        >
          Your Emissions{" "}
          <Box component={"span"} color={green[400]}>
            Reduction
          </Box>{" "}
          Plan
        </Typography>
        <Typography
          variant={"h5"}
          color={"primary.contrastText"}
          align={"center"}
        >
          Review and adjust your plan
        </Typography>
      </Stack>
    }
    bodyContent={<Dashboard />}
  />
);

export default DashboardPage;
